import type {GetAllUsersApiArg, GetChangeCommitersApiArg} from '../../../services/rest'

export const allUsersArg: GetAllUsersApiArg = {fields: 'user(id,name,username,avatars)'}

export const getChangesCommitersArg = (changeLocator: string): GetChangeCommitersApiArg => ({
  changeLocator,
  fields: 'count,commiter(vcsUsername,users(count,user(id,name,username,avatars)))',
})
